import { useCallback } from 'react'

import {
  monitoringActionsSelector,
  monitoringSelector,
  paramsSelector,
  useStore,
  useStoreApi,
} from '@liveHelper/models/store'
import { useTrackStartMonitor } from '@liveHelper/tracking/useLiveHelperTracking'
import { useSocketContext } from '@oneToOne/shared/contexts/SocketContext'
import type { PushEvent, ServerEvent } from '@oneToOne/shared/ws/monitoring'

import { useIsFocusedTab } from '@core/hooks/useIsFocusedTab'
import { useChannel } from '@core/phoenix'
import { getGuestId } from '@core/tracking/guestId'

const EMPTY_PAYLOAD = {}

/**
 * Hook to create and join monitoring channel.
 * @returns The channel instance
 * @private Private to MonitoringChannelContext
 */
export function useMonitoringChannel() {
  const { socket } = useSocketContext()
  const { chat_channel_id: chatChannelId } = useStore(paramsSelector)
  const isMonitoring = useStore(monitoringSelector)
  const isFocusedTab = useIsFocusedTab()
  const visitorId = getGuestId()
  const topic = chatChannelId ? `oto:monitor:${chatChannelId}:${visitorId}` : ''
  const storeApi = useStoreApi()
  const trackStartMonitor = useTrackStartMonitor()

  const onJoinSuccess = useCallback(() => {
    monitoringActionsSelector(storeApi.getState()).takeFullSnapshot?.()
    trackStartMonitor()
  }, [storeApi, trackStartMonitor])

  return useChannel<PushEvent, ServerEvent>({
    socket,
    topic,
    payload: EMPTY_PAYLOAD,
    shouldJoin: !!(topic && isMonitoring && isFocusedTab),
    onJoinSuccess,
  })
}
